import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { View } from '@olxbr/design-system/web'

import medias from '../../../util/medias'
import PasswordChangedTemplate from '../../templates/PasswordChangedTemplate'
import Paper from '../../atoms/Paper'
import HRule from '../../atoms/HRule'
import TextCallout from '../../molecules/TextCallout'

const Content = styled(Paper)`
  display: flex;
  flex-direction: column;
  margin: ${() => '64px auto'};
  max-width: 466px;
  ${medias.medium`
    margin: 0;
  `}
`

const HRuleWrapper = styled(View)`
  margin-top: 48px;
  margin-right: 0;
  margin-bottom: 24px;
  margin-left: 0;
`

export class ChangedPasswordPage extends React.Component {
  render() {
    const { onAccessClick } = this.props

    return (
      <Content>
        <PasswordChangedTemplate />
        <HRuleWrapper>
          <HRule />
        </HRuleWrapper>
        <TextCallout
          text="Comece a usar a OLX"
          linkText="Entrar"
          href="/acesso"
          onClick={onAccessClick}
        />
      </Content>
    )
  }
}

ChangedPasswordPage.propTypes = {
  onAccessClick: PropTypes.func,
}
